import { render, staticRenderFns } from "./GuidanceScheduleTable.vue?vue&type=template&id=4525c83a&scoped=true&"
import script from "./GuidanceScheduleTable.vue?vue&type=script&lang=js&"
export * from "./GuidanceScheduleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4525c83a",
  null
  
)

export default component.exports